import axios from "axios";

class SectionService {
  static getMenu = (siteId) => axios.get("/@menus", { params: { siteId } }).then((response) => response.data);

  static getFooter = (siteId) => axios.get("/@footer", { params: { siteId } }).then((response) => response.data);

  static getHeader = (siteId) => axios.get("/@header", { params: { siteId } }).then((response) => response.data);
}

export default SectionService;
